import {
	type MutableRefObject,
	type Ref,
	type RefCallback,
	useMemo,
} from 'react'

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
export function useMergeRefs<Instance>(
	refs: Array<Ref<Instance> | undefined>,
): RefCallback<Instance> | null {
	return useMemo(() => {
		if (refs.every((ref) => ref == null)) {
			return null
		}

		return (value) => {
			for (const ref of refs) {
				if (typeof ref === 'function') {
					ref(value)
				} else if (ref != null) {
					;(ref as MutableRefObject<Instance | null>).current = value
				}
			}
		}
		// oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
	}, refs)
}
